import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import { FC } from 'react';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import { Label, ControlledTextInput, WsButton } from 'wisestep-base';
import { object, string } from 'yup';

export interface JobBoardLoginFormProps {
  jobBoardName: string;
  saveHandler(data: FieldValues);
}
const JobBoardLoginForm: FC<JobBoardLoginFormProps> = ({ jobBoardName, saveHandler }) => {
  const validationSchema = object().shape({
    jobBoardUserName: string().required('Username is required'),
    jobBoardPassword: string().required('Password is required'),
  });
  const formDefValues = {
    jobBoardUserName: '',
    jobBoardPassword: '',
  };
  const formOptions = {
    resolver: yupResolver(validationSchema),
    defaultValues: formDefValues,
  };
  const methods = useForm(formOptions);
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <Grid alignItems="center" spacing={2} container>
        <Grid item xs={2} md={2} borderRadius={1.5}>
          <Label>{jobBoardName}</Label>
        </Grid>
        <Grid item xs={3} md={4} borderRadius={1.5}>
          <ControlledTextInput
            name="jobBoardUserName"
            labelText="Username*:"
            type="text"
            fullWidth
            id="jobBoardUserName"
            placeholder="Username"
            variant="outlined"
            required
          />
        </Grid>

        <Grid item xs={4} md={4} borderRadius={1.5}>
          <ControlledTextInput
            name="jobBoardPassword"
            labelText="Password*:"
            type="text"
            fullWidth
            id="jobBoardPassword"
            placeholder="Password"
            variant="outlined"
            required
          />
        </Grid>
        <Grid marginTop={3} item xs={2} md={2} borderRadius={1.5}>
          <WsButton onClick={handleSubmit(saveHandler)} type="submit" variant="contained">
            Save Changes
          </WsButton>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
export default JobBoardLoginForm;
